import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  0% {
    animation-timing-function: cubic-bezier(0.2242, 0.7499, 0.3142, 0.8148);
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1040;
  background-color: rgba(0, 0, 0, 0.3);
  animation: ${fadeIn} 0.3s 1 ease-in;
  animation-fill-mode: forwards;
  opacity: 0;
`;

export const ModalWrapper = styled.div`
  /* position: fixed;
  top: 0;
  left: 0;
  z-index: 1050; */
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  display: flex;
  align-items: center;
`;

const sizes = {
  small: '500px',
  medium: '700px',
  large: '85%',
};
export const ModalBody = styled.div<{ size: 'small' | 'medium' | 'large' }>`
  z-index: 1040;
  background: ${props => props.theme.body.bgColor};
  position: relative;
  margin: auto;
  border-radius: 5px;
  max-width: ${props => sizes[props.size] || sizes['medium']};
  width: 95%;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em;
  font-size: 1.125em;
  font-weight: 600;
`;

export const ModalContent = styled.div`
  padding: 1em;
  font-size: 0.95em;
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1em;

  button {
    margin-left: 6px;
  }
`;

export const ModalClose = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  color: ${props => props.theme.button.secondary.bgColor};
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 5px 5px 0;

  &:hover {
    color: ${props => props.theme.button.secondary.hover};
  }
`;
